'use strict';
const angular = require('angular');

/*@ngInject*/
export function PiperGuestService($resource) {

  return $resource('/api/piper/guests/:id', {
    id: '@_id'
  },{
    update: {
      method: 'PUT'
    },
    patch: {
      method: 'PATCH'
    },
    getByHost: {
      method: 'GET',
      url: "/api/piper/guests/host/:hostId",
      isArray: true
    }
  });

}

export default angular.module('conduuApp.PiperGuestService', [])
  .factory('PiperGuestService', PiperGuestService)
  .name;



// WEBPACK FOOTER //
// ./client/services/piper-guest/piper-guest.service.js